__turbopack_context__.v({
  "footer": "PortalLocationMap-module__6ZtmTG__footer",
  "frame": "PortalLocationMap-module__6ZtmTG__frame",
  "map": "PortalLocationMap-module__6ZtmTG__map",
  "placeholder": "PortalLocationMap-module__6ZtmTG__placeholder",
});
